import React from 'react';
import PropTypes from 'prop-types';

export default function MobileBanner({ whitelabel }) {
    return whitelabel === 'blocket' ? (
        <div
            id="index_panorama"
            className="tag panorama inview load"
            data-horseshoe-banner
            data-astbanner-name="index_panorama"
            data-testid="index_panorama"
            aria-hidden="true"
            style={{ minHeight: 240 }}
        />
    ) : (
        <div
            id="topboard"
            className="banners__topboard u-text-center"
            style={{ height: '150px' }}
            data-horseshoe-banner
            data-astbanner-name="topboard"
            data-testid="topboard"
            aria-hidden="true">
            <div id="topboard-button" className="banners-cogwheel-button" />
        </div>
    );
}

MobileBanner.propTypes = {
    whitelabel: PropTypes.string,
};
